export default __webpack_public_path__ + "static/media/PTC.2f95454a.png";